import React, { useState, useEffect } from "react";

import { MATCHING_ERRORS_MESSAGES } from "../../constants";
import IntraTableMessage from "../HOC/intratable-message/intratable-message.component";

const ErrorMessage = ({ error, customMessage = null }) => {
  const [errorMessage, setErrorMessage] = useState(
    MATCHING_ERRORS_MESSAGES.BACKEND_SERVICE
  );

  useEffect(() => {
    if (error?.graphQLErrors?.length) {
      error?.graphQLErrors?.forEach(({ extensions }) => {
        if (extensions?.exception?.isMatcherError)
          setErrorMessage(MATCHING_ERRORS_MESSAGES.MATCHING_ALGORYTHM);
      });
    }

    if (error?.networkError?.statusCode === 401) {
      setErrorMessage(MATCHING_ERRORS_MESSAGES.AUTH);
    }
  }, [error]);

  if (customMessage) {
    return (
      <IntraTableMessage>
        <div className="err-msg">{customMessage}</div>
      </IntraTableMessage>
    );
  }

  return (
    <IntraTableMessage>
      <div className="err-msg">{errorMessage}</div>
    </IntraTableMessage>
  );
};

export default ErrorMessage;
